import React from 'react';
import { TextButton } from '@wix/design-system';
import { appsSectionDataHooks } from './data-hooks';
import { useEssentials } from '../../contexts/essentials-context';

export interface SeeAllButtonProps {
  href?: string;
  onClick: () => void;
}

export function SeeAllButton({ href, onClick }: SeeAllButtonProps) {
  const { t } = useEssentials();

  return (
    <TextButton
      href={href}
      skin="standard"
      as="a"
      size="tiny"
      weight="normal"
      dataHook={appsSectionDataHooks.button}
      onClick={(e) => {
        onClick();
        e.preventDefault();
      }}
    >
      {t('apps.section.see.all.button')}
    </TextButton>
  );
}
